import { render, staticRenderFns } from "./userRegister.vue?vue&type=template&id=5ad48a6c&"
import script from "./userRegister.vue?vue&type=script&lang=js&"
export * from "./userRegister.vue?vue&type=script&lang=js&"
import style0 from "./userRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports